import { create } from 'zustand';

export const useUserDetails = create((set) => ({
  userDetails: null,
  setUserDetails: (data) => set(() => ({ userDetails: data })),
  resetUserDetails: () => set(() => ({ userDetails: null })),
}));
